import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/config'

Vue.use(Vuex)

// Rol del auth de terrada (servicio aislado) que habilita "ver como"; se asigna a mano en su base
export const SUPERUSER_ROLE = 'super_admin'

function readViewAs() {
  try {
    return JSON.parse(localStorage.getItem('view_as') || 'null')
  } catch (e) {
    return null
  }
}

function hasSuperuserRole(profile) {
  return !!profile && Array.isArray(profile.roles) && profile.roles.includes(SUPERUSER_ROLE)
}

export default new Vuex.Store({
  state: {
    credentials: {
      fedacct: (JSON.parse(localStorage.getItem('user_profile') || 'null') || {}).email || '',
      password: '',
      name: (JSON.parse(localStorage.getItem('user_profile') || 'null') || {}).name || '',
      dni: (JSON.parse(localStorage.getItem('user_profile') || 'null') || {}).dni || '',
      telefono: (JSON.parse(localStorage.getItem('user_profile') || 'null') || {}).telefono || '',
      role: (JSON.parse(localStorage.getItem('user_profile') || 'null') || {}).role || '',
      access_token: localStorage.getItem('access_token') || '',
      refresh_token: localStorage.getItem('refresh_token') || '',
      user_payload: JSON.parse(localStorage.getItem('user_payload') || 'null'),
      thalamus_server: config.MONOLITO_API
    },
    authenticated: false,
    user_profile: JSON.parse(localStorage.getItem('user_profile') || 'null'),
    turno: {
      profesional_name: '',
      especialidad: '',
      start: '',
      end: '',
      direccion: 'Calle Terrada 374'
    },
    snackbar: {
      show: false,
      text: '',
      color: 'info',
      timeout: 3000
    },
    country_code: 'AR',
    // Superusuario viendo como otro perfil: { perfil, target, real_profile }
    // perfil: 'secretaria' | 'medico' | 'paciente'; target: usuario elegido (médico/paciente)
    view_as: readViewAs()
  },

  getters: {
    accessToken: state => state.credentials.access_token || localStorage.getItem('access_token'),
    refreshToken: state => state.credentials.refresh_token || localStorage.getItem('refresh_token'),
    userPayload: state => state.credentials.user_payload || JSON.parse(localStorage.getItem('user_payload') || 'null'),
    isAuthenticated: state => state.authenticated && !!state.credentials.access_token,
    // Perfil real del usuario logueado (aunque esté viendo como otro)
    realProfile: state => (state.view_as && state.view_as.real_profile) || state.user_profile,
    isSuperuser: (state, getters) => hasSuperuserRole(getters.realProfile),
    // Email del usuario que se está viendo (va en el header X-View-As); null si no aplica
    viewAsEmail: state => {
      const v = state.view_as
      return v && v.target && v.target.email ? v.target.email : null
    }
  },

  mutations: {
    set_credentials(state, login_info) {
      state.credentials.fedacct = login_info.federation_acct;
      state.credentials.password = login_info.password;
      state.credentials.name = login_info.name
      state.credentials.dni = login_info.dni
      state.credentials.role = login_info.role
      state.credentials.telefono = login_info.telefono
      state.credentials.thalamus_server = config.MONOLITO_API;
      state.authenticated = true;
    },
    set_auth_tokens(state, { access_token, refresh_token, user_payload }) {
      state.credentials.access_token = access_token;
      state.credentials.refresh_token = refresh_token;
      state.credentials.user_payload = user_payload;
      state.authenticated = true;

      // Guardar en localStorage
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      if (user_payload) {
        localStorage.setItem('user_payload', JSON.stringify(user_payload));
      }
    },
    set_authenticated(state, authenticated) {
      state.authenticated = authenticated;
    },
    showSnackbar(state, { text, color = 'info', timeout = 3000 }) {
      state.snackbar = {
        show: true,
        text,
        color,
        timeout
      };
    },
    set_turno(state, turno_info) {
      state.turno.profesional_name = turno_info.profesional_name
      state.turno.especialidad = turno_info.especialidad
      state.turno.start = turno_info.start
      state.turno.end = turno_info.end
    },
    set_user_profile(state, profile) {
      state.user_profile = profile;
      // Guardar en localStorage
      localStorage.setItem('user_profile', JSON.stringify(profile));
    },
    // Superusuario: pasa a ver la app como otro perfil. profile es el perfil
    // sintético con el que se renderizan las vistas (rol + datos del usuario elegido).
    start_view_as(state, { perfil, target, profile }) {
      const realProfile = (state.view_as && state.view_as.real_profile) || state.user_profile
      state.view_as = { perfil, target: target || null, real_profile: realProfile }
      localStorage.setItem('view_as', JSON.stringify(state.view_as))
      state.user_profile = profile
      localStorage.setItem('user_profile', JSON.stringify(profile))
      state.credentials.fedacct = profile.email || ''
      state.credentials.name = profile.name || ''
      state.credentials.dni = profile.dni || ''
      state.credentials.telefono = profile.telefono || ''
      state.credentials.role = profile.role || ''
    },
    reset_credentials(state) {
      state.credentials.fedacct = '';
      state.credentials.password = '';
      state.credentials.name = '';
      state.credentials.role = '';
      state.credentials.dni = '';
      state.credentials.telefono = '';
      state.credentials.access_token = '';
      state.credentials.refresh_token = '';
      state.credentials.user_payload = null;
      state.user_profile = null;
      state.view_as = null;

      // Limpiar localStorage
      localStorage.removeItem('view_as');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user_payload');
      localStorage.removeItem('user_profile');
      state.credentials.thalamus_server = config.MONOLITO_API;
      state.authenticated = false;

      // Limpiar localStorage
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user_payload');
    }
  },

  actions: {
    clearAuth({ commit }) {
      commit('reset_credentials');
    },
    setAuth({ commit }, { access_token, refresh_token, user_payload }) {
      commit('set_auth_tokens', { access_token, refresh_token, user_payload });
    }
  }
})
